import dayjs from 'dayjs';

import * as T from './Form.types';

export const createSpeaker: T.TCreateSpeaker = async (
  user,
  body,
  updateUser,
  doRegistration
) => {
  //массивы ссылок файлов загруженных на S3
  const fileCharterUrls: string[] = [];
  const fileLettersOfHonorUrls: string[] = [];
  const officialPhotoUrls: string[] = [];

  try {
    await Promise.all(
      body.fileCharter.map(async (file) => {
        const fileUrl: string = await ZnanieSDK.uploadToS3(file, {
          folder: 'speakers/scans',
        });
        fileCharterUrls.push(fileUrl);
      })
    );

    await Promise.all(
      body.fileLettersOfHonor.map(async (file) => {
        const fileUrl: string = await ZnanieSDK.uploadToS3(file, {
          folder: 'speakers/scans',
        });
        fileLettersOfHonorUrls.push(fileUrl);
      })
    );

    await Promise.all(
      body.officialPhoto.map(async (file) => {
        const fileUrl: string = await ZnanieSDK.uploadToS3(file, {
          folder: 'speakers/official_photos',
        });
        officialPhotoUrls.push(fileUrl);
      })
    );

    await updateUser({
      firstName: body.firstName,
      lastName: body.lastName,
      middleName: body.patronymic,
      email: body.email,
      phone: body.phone,
      birthDate: body.birthDate
        ? dayjs(body.birthDate).format('YYYY-MM-DD')
        : '',
      address: body.region,
      addressDetail: body.addressDetail,
      position: body.post,
      workPlace: body.work,
      regalia: body.regalia,
      whichUniversity: body.whichUniversity,
      graduationYear: body.graduationYear,
      vkAccount: body.socials[0].link,
      telegramAccount: body.socials[1].link,
    });

    await doRegistration({
      university: body.university.trim(),
      fileCharter: fileCharterUrls,
      fileLettersOfHonor: fileLettersOfHonorUrls,
      officialPhoto: officialPhotoUrls[0],
      performanceUrl: body.performanceUrl,
      category: body.activity ? [body.activity.value] : null,
      comments: body.comment,
      enrollToLeagueOfLecturers: user.leagueLecturersEnrollment
        ? false
        : body.isEnrolledToLeagueOfLecturers,
    });
    if (ZnanieSDK) {
      ZnanieSDK.refetchUser();
    }
  } catch (err) {
    throw err;
  }
};
